import type { AvailableFiltersType, StoreShortWithSupplierType } from '@/types'
import { sortStores } from '@/utils/search/stores/sortStores'

export class FiltersTransformService {
  flattenStores(
    availableFilters: AvailableFiltersType
  ): StoreShortWithSupplierType[] {
    if (!availableFilters.stores) return []

    return sortStores(
      availableFilters.stores.flatMap((supplier) =>
        supplier.stores.map((store) => ({
          ...store.storeShortModel,
          supplierId: supplier.supplierId,
          count: store.count,
        }))
      )
    )
  }
}

export const filtersTransformService = new FiltersTransformService()
